import { EM_DASH } from "@/lib/utils";

/** Calendar date from a `date` or midnight `timestamptz` API value. */
export function formatManufacturerInvoiceDate(value: string | null | undefined): string {
  if (value == null || value.trim() === "") {
    return EM_DASH;
  }
  const isoDate = /^(\d{4}-\d{2}-\d{2})/.exec(value.trim());
  if (isoDate == null) {
    return value;
  }
  const parsed = Date.parse(`${isoDate[1]}T12:00:00`);
  if (!Number.isFinite(parsed)) {
    return isoDate[1];
  }
  return new Date(parsed).toLocaleDateString();
}

export function manufacturerInvoiceDateInputValue(value: string | null | undefined): string {
  if (value == null) return "";
  const isoDate = /^(\d{4}-\d{2}-\d{2})/.exec(value.trim());
  return isoDate?.[1] ?? "";
}
